import styled from '@emotion/styled'
import { BREAKPOINTS, pxToRem } from 'utils/styled'
import { Text } from 'components/Typography'

export const STabItems = styled.div`
  display: flex;
  flex: 1;
  flex-wrap: wrap;
  @media ${BREAKPOINTS.MD.min} {
    &::after {
      content: '';
      flex-grow: 99;
    }
  }
`

export const SItem = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  flex-grow: 1;
  margin: 10px;
`

export const SItemView = styled.div`
  overflow: hidden;
  display: flex;
  flex: 1;
  & > * {
    flex: 1;
  }
`

export const STitle = styled(Text)`
  height: ${pxToRem(28)}rem;
  margin: ${pxToRem(6)}rem 0;
`

export const STitleActionRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 1rem 10px 0;
`
